import styled from 'styled-components'

import {
  List,
  ListItemText as MuiListItemText,
  ListItemButtonProps as MuiListItemButtonProps,
  ListItemButton as MuiListItemButton,
  Stack,
  Typography,
  Link,
  Button
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { NavLink, NavLinkProps } from 'react-router-dom'

type ListItemButtonProps = MuiListItemButtonProps & NavLinkProps

const Wrapper = styled('div')`
  display: flex;
  padding: ${(props) => props.theme.spacing(2)} ${(props) => props.theme.spacing(4)};
  background: ${(props) => props.theme.footer.background};
  position: relative;
  width: 100%;
  margin-top: 24px;
`

const ListItemButton = styled(MuiListItemButton)<ListItemButtonProps>`
  display: inline-block;
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};

  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.footer.color};
  }
`

function Footer() {
  /**
   * The translate function.
   */
  const [t] = useTranslation('common')

  return (
    <Wrapper>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <List
          sx={{
            display: 'inline-flex',
            p: '0 !important',
            height: '100%'
          }}
        >
          <ListItemButton component={NavLink} to="/auth/privacy-policy">
            <ListItemText primary={t('privacyPolicy')} />
          </ListItemButton>
          <ListItemButton component={NavLink} to="/auth/terms-of-service">
            <ListItemText primary={t('termsOfService')} />
          </ListItemButton>
        </List>

        <Stack direction="row" alignItems="center" gap={6}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            component={Link}
            href="mailto:jira@spine-electric.atlassian.net"
          >
            {t('Navbar.bugReport')}
          </Button>
          <Typography>{`© ${new Date().getFullYear()} - Spine`}</Typography>
        </Stack>
      </Stack>
    </Wrapper>
  )
}

export default Footer
